// removed by extract-text-webpack-plugin
module.exports = {"Restore":"Restore__Restore__2ZYSc","ToolTip":"Restore__ToolTip__FzDYv","Attempts":"Restore__Attempts__vNQdz","ToolTipText":"Restore__ToolTipText__3jmKV","Clicked":"Restore__Clicked__1-RUX","Remind":"Restore__Remind__31-Ue","shake":"Restore__shake__2bTYF"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/GameMenu/ListElements/Restore/Restore.css
// module id = 100
// module chunks = 0